import CMSPage from './CMSPage';

/**
 * Homepage component - fetches 'home' page from CMS
 */
const HomePage: React.FC = () => {
  return <CMSPage slug="home" />;
};

export default HomePage;
